module.exports = __webpack_public_path__ + "static/media/p208intel.9cd71eb5.jpg";